import { Component, ComponentFactoryResolver, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PedidoService } from 'src/app/services/pedido.service';
import { ModalMensajeComponent } from '../general/modal-mensaje/modal-mensaje.component';
import { GLOBAL } from 'src/app/services/global';


@Component({
  selector: 'app-pedido',
  templateUrl: './pedido.component.html',
  styleUrls: ['./pedido.component.css']
})
export class PedidoComponent implements OnInit {

  userLogin: any;
  pedido: any;
  refModalMensaje: any = {};
  showDetallesPedido: boolean = false;
  url: string;

  colores: any[] = [
    {id: 1, color: 'success'},     
    {id: 2, color: 'orange'},     
    {id: 3, color: 'silver'},        
    {id: 4, color: 'warning'},    
    {id: 5, color: 'teal'},        
    {id: 6, color: 'success'},    
    {id: 7, color: 'danger'},     
    {id: 8, color: 'success'},     
    {id: 9, color: 'warning'},   
    {id: 10, color: 'danger'}      
];
  @ViewChild('modalMensaje', { read: ViewContainerRef, static: false }) entry: ViewContainerRef;

  constructor(
    private route: ActivatedRoute,
    private pedidoService: PedidoService,
    private resolver: ComponentFactoryResolver,
    private router: Router
  ) { 
    this.url = GLOBAL.url;
  }

  @HostListener('window:popstate', ['$event'])
    onPopState(): void {
      this.router.navigate(['/perfil'], { 
        queryParams: { opcion: 'pedidos' } 
      });
  }

  ngOnInit() {

    this.userLogin = JSON.parse(localStorage.getItem("user"));

    this.route.queryParams.subscribe(result => {
      this.getPedido(result.token);
    });
  }

  getPedido(token: string) {
    console.log(token);
    this.pedidoService.getPedido(token).subscribe(result => {
      if(result.result == "ok"){
        this.pedido = result.pedido;
        console.log("pedido",this.pedido);
      }else{
        this.mostrarMensajeModal("Pedido", "Se ha producido un error al obtener el pedido");
      }
    });
  }

  formatearPrecio(precio: any): string {
    const num = parseFloat(precio);
    if (isNaN(num)) return '0,00';
    
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');
  }

  getColorEstado(estadoId: number): string {
    const colorObj = this.colores.find(color => color.id === estadoId);
    return colorObj ? 'badge-'+colorObj.color : 'badge-gray'; 
  }

  mostrarMensajeModal(titulo, mensaje) {
    this.entry.clear();
    const factory = this.resolver.resolveComponentFactory(ModalMensajeComponent);
    this.refModalMensaje = this.entry.createComponent(factory);
    this.refModalMensaje.instance.mensaje = mensaje;
    this.refModalMensaje.instance.titulo = titulo;
    this.refModalMensaje.changeDetectorRef.detectChanges();
  }

  toggleDetallesPedido() {
    this.showDetallesPedido = !this.showDetallesPedido;
  }

  abrirWhatsapp() {
    const numeroWhatsApp = '34619268739';
    const mensaje = `Hola, necesito ayuda con una incidencia sobre mi pedido ${this.pedido.numero}. Mi problema es que...(describe tu problema y como podemos ayudarte y te responderemos lo antes posible)`;
    const urlWhatsApp = `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(mensaje)}`;
    window.open(urlWhatsApp, '_blank');
  }

}
